"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENT_SUPPLIERS = void 0;
var CURRENT_SUPPLIERS = {
  INPUT__SEARCH: 'currentSuppliers-input-search',
  TEXT__SUPPLIER_NAME: 'currentSuppliers-span-supplierName'
};
exports.CURRENT_SUPPLIERS = CURRENT_SUPPLIERS;